import { VehicleStatus } from "@/api-schema-enums";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const VEHICLE_STATUS_TRANSLATION_KEYS = {
  [VehicleStatus.Incoming]: "masterdata:VehicleStatusIncoming",
  [VehicleStatus.InStock]: "masterdata:VehicleStatusInStock",
  [VehicleStatus.Sold]: "masterdata:VehicleStatusSold",
  [VehicleStatus.Historic]: "masterdata:VehicleStatusHistoric",
  [VehicleStatus.ZGMAdmin]: "masterdata:VehicleStatusZGMAdmin",
  [VehicleStatus.UNKNOWN]: "masterdata:VehicleStatusUnknown",
} as const satisfies Record<VehicleStatus, string>;

export function getVehicleStatusLabel(value: VehicleStatus | null | undefined, t: TranslateFn): string | undefined {
  if (!value) {
    return undefined;
  }

  return t(VEHICLE_STATUS_TRANSLATION_KEYS[value]);
}
